/**
 * 「场景批量生成」（Case-Flow / Jira 两个 tab）单批条数上限 —— **与后端同值**。
 *
 * 单一数据源在后端 `api/schemas/common.py` 的 `SCENE_BATCH_MAX_CASES = 50_000`，
 * 三处共用：提交前预检 `/scene-creation/scenes/existing-completed`、提交
 * `/scene-creation/from-caseflow` 与 `/scene-creation/from-jira`。改后端记得同步这里。
 *
 * 为什么是 5 万：报文不是瓶颈（5 万条 case_id 才 ~1MB，网关是 50MB 量级），
 * 真正的成本是每个 case 一次 Case-Flow RPC + 一次落库（后台串行）+ 完成态整包回包。
 *
 * 前端只做「提交前拦截 + 提示」，真正的闸门在后端 —— 超限返回业务错误文案
 * （code != 0），不再是 Pydantic 的裸 422。
 */
export const MAX_BATCH_CASES = 50000;

/** 人读文案（提示 / 报错共用）：`5 万`。 */
export const MAX_BATCH_CASES_LABEL = '5 万';

/** 超限文案：与后端 `scene_batch_limit_message` 同款，用户在哪一侧被拦看到的都一样。 */
export const batchLimitMessage = (count: number): string =>
  `单批最多 ${MAX_BATCH_CASES_LABEL}个 case，本次输入 ${count} 个，请分批提交`;